import { AlertTriangle, Loader2, RefreshCw } from 'lucide-react';

interface SecureUploadCompanyProfileStatusProps {
  loading: boolean;
  onRetry: () => void;
}

export function SecureUploadCompanyProfileStatus({
  loading,
  onRetry
}: SecureUploadCompanyProfileStatusProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50/30 to-cyan-50/20 flex items-center justify-center p-6">
      <div
        className="w-full max-w-lg rounded-2xl border border-cyan-200/50 bg-white p-8 text-center shadow-xl shadow-blue-900/10"
        role={loading ? 'status' : 'alert'}
        aria-live={loading ? 'polite' : 'assertive'}
      >
        {loading ? (
          <>
            <Loader2 className="mx-auto mb-5 h-10 w-10 animate-spin text-cyan-600" aria-hidden="true" />
            <h1 className="text-2xl font-bold text-gray-900">Loading secure upload portal</h1>
            <p className="mt-3 text-sm text-gray-600">
              Verifying company licensing and compliance information.
            </p>
          </>
        ) : (
          <>
            <AlertTriangle className="mx-auto mb-5 h-10 w-10 text-amber-600" aria-hidden="true" />
            <h1 className="text-2xl font-bold text-gray-900">Secure upload is temporarily unavailable</h1>
            <p className="mt-3 text-sm leading-6 text-gray-600">
              We could not verify the company licensing information required for this page. No documents have been sent.
            </p>
            <button
              type="button"
              className="mt-6 inline-flex items-center gap-2 rounded-lg bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground transition-colors hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
              onClick={onRetry}
            >
              <RefreshCw className="h-4 w-4" aria-hidden="true" />
              Try again
            </button>
          </>
        )}
      </div>
    </div>
  );
}
